<template>
  <!-- 需要判断集群还是实例 集群跟实例的属性不一样 -->
  <div class="redisDetail">
    <div class="redisDetail-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <!-- <BreadcrumbItem>{{ this.$route.query.cacheClusterId }}</BreadcrumbItem> -->
        <BreadcrumbItem to="/monitor/DocDBMonitor">DocDB</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Row type="flex" justify="space-between" class="code-row-bg">
      <Col span="6">
        <Card style="height: 480px">
          <Row>
            <Row style="height: 200px">
              <Col
                span="24"
                style="
                  text-align: center;
                  font-size: 103px;
                  display: block;
                  margin-top: 8px;
                "
              >
                <Icon type="logo-buffer" />
              </Col>
              <Col style="text-align: center; font-size: 18px">{{
                this.$route.query.cacheClusterId
              }}</Col>
            </Row>
            <Row style="margin-bottom: 20px">
              <Col>{{ $t("DocDBMonitor.redshiftDescription") }}</Col>
              <Col>---</Col>
            </Row>
            <Row>
              <Col style="margin-bottom: 8px">{{
                $t("DocDBMonitor.redshiftConfig")
              }}</Col>
              <Row :gutter="16">
                <Col span="10">{{ $t("DocDBMonitor.dbClusterMembers") }}:</Col>
                <Col span="12">{{ getRowData.number }}</Col>
              </Row>
              <Row :gutter="16">
                <Col span="10">{{ $t("DocDBMonitor.roleName") }}:</Col>
                <Col span="12">{{ this.$route.query.roleName }}</Col>
              </Row>
              <!-- <Row>
                <Col style="margin-bottom: 8px">{{
                  $t("alarms.instance.instanceConfiguration")
                }}</Col>
              </Row> -->
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="13">
        <Card style="height: 480px">
          <ul class="content">
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-laptop"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("DocDBMonitor.redshiftInfo") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>
                              {{ $t("DocDBMonitor.ClusterIdentifier") }}：
                            </li>
                            <li>
                              {{ getRowData.flag }}
                            </li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>
                              {{ $t("DocDBMonitor.clusterCreateTime") }}：
                            </li>
                            <li>{{ getRowData.creatTime }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("DocDBMonitor.engineVersion") }}：</li>
                            <li>{{ getRowData.version }}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-pulse"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.monitorMessage") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.monitorItems") }}：</li>
                            <li>
                              {{ monitoringNum }}{{ $t("alarms.common.count") }}
                            </li>
                          </ul>
                        </Col>
                        <Col>
                          <a @click="monitorRedshift">{{
                            $t("alarms.common.viewMonitoringOverview")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-medkit-outline"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.alertRule") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.alertRule") }}：</li>
                            <li>{{ priorityNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.untreated") }}：</li>
                            <li>{{ statusNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <a @click="alertRule">{{
                            $t("alarms.common.viewAlarmRules")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
          </ul>
        </Card>
      </Col>
      <Col span="4">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <!-- 阿里云 -->
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import utils from "@/utils/utils.js";
export default {
  name: "RedisDetail",
  data() {
    return {
      id: "",
      accountId: "",
      accountTypeName: "",
      accountType: "",
      accountName: "",
      region: "",
      cacheClusterId: "",
      instanceId: "",
      priorityNum: "",
      statusNum: "",
      monitoringNum: "",
      type: "",
      tagList: [],
      getRowData: {}
    };
  },
  mounted() {
    this.getEsDetailById();
  },
  methods: {
    init: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.instanceId = this.$route.query.instanceId;
      this.region = this.$route.query.region;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.type = this.$route.query.type;
      this.cacheClusterId = this.$route.query.cacheClusterId;
    },
    // 详情
    getEsDetailById: function() {
      this.$api.DocDB.documentDBClusterDetail({
        docDbId: this.$route.query.id,
        accountId: this.$route.query.accountId,
        roleName: this.$route.query.roleName
      }).then(res => {
        this.getRowData = res.data;
        if (this.$route.query.roleName == "集群") {
          // this.getRowData.dbClusterIdentifier = res.data.dbClusterIdentifier;
          this.getRowData = {
            flag: res.data.dbClusterIdentifier,
            creatTime: res.data.clusterCreateTime,
            number: res.data.dbClusterMembers,
            version: res.data.engineVersion,
            name: this.$route.query.roleName,
            monitorModule: res.data.monitorModule
          };
        } else {
          this.getRowData = {
            flag: res.data.dbInstanceIdentifier,
            creatTime: res.data.instanceCreateTime,
            version: res.data.engineVersion,
            name: this.$route.query.roleName,
            monitorModule: res.data.monitorModule
          };
        }
        this.priorityNum = res.data.priorityNum;
        this.statusNum = res.data.statusNum;
        this.monitoringNum = res.data.monitoringNum;
        // this.name = res.data.name;
        // this.tagList = res.data.tags;
      });
    },
    // 点击查看监控概览
    monitorRedshift: function() {
      this.init();
      this.$router.push({
        path: "/monitor/DocDBMonitor/DocDB/",
        query: {
          id: this.id,
          accountId: this.accountId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          cacheClusterId: this.cacheClusterId,
          // instanceId: this.instanceId,
          name: this.name,
          monitorModule: this.getRowData.monitorModule,
          instanceId: this.getRowData.flag,
          roleName: this.$route.query.roleName
        }
      });
    },
    // 点击查看报警规则
    alertRule: function() {
      this.init();
      this.$router.push({
        path: "/monitor/DocDBMonitor/DocDBWarning/",
        query: {
          id: this.id,
          accountId: this.accountId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          cacheClusterId: this.cacheClusterId,
          type: this.type,
          monitorModule: this.getRowData.monitorModule,
          roleName: this.$route.query.roleName
        }
      });
    }
  }
};
</script>

<style scoped>
.redisDetail-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.host ul {
  list-style: none;
  overflow: hidden;
}
.host ul li {
  float: left;
}
.content > li {
  margin-bottom: 6px;
  border-bottom: 1px dashed #ccc;
  padding: 12px;
}
.content > li:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/RedisDetail.vue